import React, { useEffect, useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight, User } from "lucide-react";
import Reveal, { SectionTitle } from "../Reveal";
import { testimonials } from "../../data/mock";
import Img from "../Img";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = testimonials[i];

  // Preload toàn bộ avatar để không bị nháy / lỗi tải khi carousel đổi slide
  useEffect(() => {
    testimonials.forEach((t) => {
      if (t.avatar) {
        const img = new Image();
        img.src = t.avatar;
      }
    });
  }, []);

  useEffect(() => {
    if (navigator.userAgent === "ReactSnap") return;
    const id = setTimeout(() => setI((p) => (p + 1) % testimonials.length), 7000);
    return () => clearTimeout(id);
  }, [i]);

  return (
    <section
      data-testid="testimonials"
      className="relative py-24"
      style={{
        backgroundImage:
          "url(/images/2017_01_back12.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      aria-labelledby="testimonials-title"
    >
      <div className="absolute inset-0 bg-white/88" />
      <div className="relative mx-auto max-w-[900px] px-6">
        <Reveal>
          <SectionTitle
            kicker="Eat clean & Healthy food"
            title="Khách hàng nói gì về Ann Home"
            tag="h2"
          />
        </Reveal>

        <Reveal delay={120}>
          <div className="relative mt-14 text-center">
            <Quote size={40} className="mx-auto mb-6 text-[#dcd7c9]" strokeWidth={1.4} />
            <blockquote
              key={t.id}
              className="ah-fade-up mx-auto max-w-[720px] text-[17px] font-light italic leading-[1.95] text-[#4a4a4a] sm:text-[19px]"
            >
              {`“${t.text}”`}
            </blockquote>

            <div className="mt-9 flex flex-col items-center">
              {t.avatar ? (
                <Img
                  src={t.avatar}
                  alt={`Kh\u00e1ch h\u00e0ng ${t.name}`}
                  width={74}
                  height={74}
                  loading="eager"
                  decoding="async"
                  className="h-[74px] w-[74px] rounded-full object-cover ring-1 ring-black/10"
                />
              ) : (
                <span className="flex h-[74px] w-[74px] items-center justify-center rounded-full bg-[#eceade] text-[#9a9a8c]">
                  <User size={30} />
                </span>
              )}
              <p className="ah-heading mt-4 text-[15px]">{t.name}</p>
              <div className="mt-2 flex gap-1">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star
                    key={k}
                    size={14}
                    className={k < t.stars ? "text-[#e0a83c]" : "text-[#d8d5cc]"}
                    fill={k < t.stars ? "#e0a83c" : "none"}
                  />
                ))}
              </div>
            </div>

            <div className="mt-10 flex items-center justify-center gap-5">
              <button
                onClick={() => setI((p) => (p - 1 + testimonials.length) % testimonials.length)}
                aria-label="\u0110\u00e1nh gi\u00e1 tr\u01b0\u1edbc"
                className="rounded-full border border-black/12 p-2.5 text-[#5c5c5c] transition-all duration-300 hover:border-[#148456] hover:text-[#148456]"
              >
                <ChevronLeft size={17} />
              </button>
              <div className="flex gap-2">
                {testimonials.map((x, k) => (
                  <button
                    key={x.id}
                    onClick={() => setI(k)}
                    aria-label={`\u0110\u00e1nh gi\u00e1 ${k + 1}`}
                    className="h-2 w-2 rounded-full transition-all duration-400"
                    style={{
                      backgroundColor: k === i ? "#148456" : "#cfcbc1",
                      transform: k === i ? "scale(1.4)" : "scale(1)",
                    }}
                  />
                ))}
              </div>
              <button
                onClick={() => setI((p) => (p + 1) % testimonials.length)}
                aria-label="\u0110\u00e1nh gi\u00e1 sau"
                className="rounded-full border border-black/12 p-2.5 text-[#5c5c5c] transition-all duration-300 hover:border-[#148456] hover:text-[#148456]"
              >
                <ChevronRight size={17} />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
